module.exports = __webpack_public_path__ + "img/computer_blue.9c0a8632.png";